import Vue from 'vue';

export default {
    /**
     * 显示模态窗体
     * @param component 组件，由跟组件BaseModal集成其它组件形成模态窗体
     * @param opts 
     *       methods 方法
     *          beforeOk:Ok前处理
     *          afterOk:Ok后处理
     *       data 数据
     *          data： data模型
     *          其它参数：
     */
    showBaseModal(component, opts) {
        const D = Vue.extend(component)
        
        const $vm = new D({
            data: Object.assign({}, opts.data),
            methods: Object.assign({}, opts.methods),
            propsData: Object.assign({}, opts.propsData)
        })
        $vm.$mount()
        document.body.appendChild($vm.$el)
    },
}